(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["annnouncement-bar-fixed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBar(bar) {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';

      var el = bar.querySelector('.bd-rotating__msg');
      var items = bar.querySelectorAll('.bd-rotating__data li');
      var speed = parseInt(bar.dataset.speed, 10) || 6000;
      var messages = [];

      for (var n = 0; n < items.length; n++) {
        messages.push({
          text: items[n].textContent,
          url: items[n].getAttribute('data-url') || ''
        });
      }
      if (!messages.length) return;

      var i = 0;
      function show(index) {
        el.classList.remove('is-visible');
        setTimeout(function () {
          var m = messages[index];
          el.textContent = '';
          if (m.url) {
            var a = document.createElement('a');
            a.href = m.url;
            a.textContent = m.text;
            el.appendChild(a);
          } else {
            el.textContent = m.text;
          }
          el.classList.add('is-visible');
        }, 600);
      }

      show(i);
      if (messages.length > 1) {
        setInterval(function () {
          i = (i + 1) % messages.length;
          show(i);
        }, speed);
      }
    }

    function initAll() {
      var bars = document.querySelectorAll('.bd-rotating');
      for (var b = 0; b < bars.length; b++) initBar(bars[b]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
